import { unmarshalCampaign } from 'scenes/common/api/campaign/marshaller';
import { Campaign } from 'scenes/common/types';

import { WireQuoteFromApi } from '../types';

export const unmarshalCampaigns = (quote: WireQuoteFromApi): Campaign[] =>
  quote.campaigns?.map((campaign) => unmarshalCampaign(campaign)) || [];
